<div>
  <nb-select placeholder="Seleccione elemento" fullWidth="true"
  [(ngModel)]="selectedItem" (selectedChange)="updateItemElement($event)">
         <nb-option *ngFor="let item of listaOpciones" value="{{item.identifier}}">{{item.name}}</nb-option>
   </nb-select>

  </div>
